<template>
    <div :key="key" class="date-picker-custom">
        <el-date-picker
            v-model="_value"
            v-bind="$attrs"
            :popper-class="popperClass"
            :clearable="clearable"
            :value-format="valueFormat"
            :format="format"
            :unlink-panels="true"
            :picker-options="pickerOptions"
            v-on="$listeners"
 />
    </div>
</template>

<script>
import dateAndValidator from "@/utils/dateAndValidator";

export default {
  name: "DatePickerCustom",

  inheritAttrs: false,

  props: {
    popperClass: {
      default: "",
      type: String
    },

    value: {
      default: null,
      type: [Date, Array, String]
    },

    clearable:{
      type:Boolean,
      default:false
    },

    limit: {
      type: Array,
      default: () => []
    },

    format: {
      type: String,
      default: "yyyy/MM/dd"
    },

    valueFormat: {
      type: String,
      default: "yyyy-MM-dd"
    }
  },

  data() {
    return {
      key: `DatePickerCustomID-${Math.random()
        .toString(36)
        .slice(2)}`
    };
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    },

    pickerOptions() {
      const [start,end] = this.limit;

      return dateAndValidator.limit.pickerOptions({
        start: new Date(start).getTime(),
        end: new Date(end).getTime()
      });
    }
  }
};
</script>

<style lang="scss">
.date-picker-custom {
  display: inline-block;
  .el-range-editor.el-input__inner {
    width: 220px;
    background-color: #EDF3F7;
    border:0;
    padding: 3px 10px 3px 25px;
  }
  .el-range-editor .el-range-input {
    width: calc((100% - 20px - 13px) / 2);
    background-color: transparent;
  }
  .el-range-editor {
    width: 20px;
    .el-range-separator{
        width: 9%;
        margin-top: -1px;
    }
  }
  .el-range__close-icon {
    // display: none;
  }
}
.receivables .date-picker-custom .el-range-editor.el-input__inner{
    width: 310px !important;
}
</style>
